import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import partsMixin from './_parts_mixin';
import imageSelecter from '../../components/_image_selecter';
import loop from '../../components/_loop-component';
import suneditor from '../../components/common/_suneditor';
// 各パーツ編集コンポーネント
import partsEditOgariaTool from './parts_edit/_ogaria_tool';
import partsEditItem from './parts_edit/_item';
import partsEditTable from './parts_edit/_table';
import partsEditHeader from './parts_edit/_header';

/**
 * パーツ編集ベースコンポーネント
 */
export default {
    name: 'PartsEditor',
    template: '#parts_editor_template',
    data() {
        return {
            // 編集中のindex
            index: null,
            // 編集中のデータ
            parts_data: {},
            // 編集中のパーツタイプ(header,image等)
            parts_type: null,
        };
    },
    props: {
        // パーツタイプ(build_store、item等のページ)
        type: {
            type: String,
            require: true,
        },
        // 編集ID(主に画像参照に使う)
        edit_id: {
            type: [String, Number],
            default: '',
            require: false
        },
        // 連動フラグ
        device_sync: {
            type: Boolean,
            required: true
        }
    },
    mixins: [
        modalMixin
    ],
    components: {
        // 各パーツ編集コンポーネント
        'parts-edit-text': {
            template: '#parts_edit_text_template',
            data() {
                return {
                    designPatternPath: 'common/parts/text_design/',
                    designPattern: [
                        'default',
                        'border',
                        'border-thick',
                        'border-radius'
                    ]
                };
            },
            props: ['parts_data', 'type', 'edit_id', 'device_sync'],
            mixins: [
                commonMixin, partsMixin
            ],
            components: {
                'loop': loop,
                'suneditor': suneditor,
            },
        },
        'parts-edit-image': {
            template: '#parts_edit_image_template',
            data() {
                return {
                    designPatternPath: 'common/parts/image_design/',
                    designPattern: [
                        'default',
                        'rounded',
                        'border',
                        'border-thick'
                    ]
                };
            },
            props: ['parts_data', 'type', 'edit_id', 'device_sync'],
            mixins: [
                commonMixin, partsMixin,
            ],
            components: {
                'loop': loop,
                'image-selecter': imageSelecter,
            },
        },
        'parts-edit-image-text': {
            template: '#parts_edit_image_text_template',
            data() {
                return {
                    designPatternPath: 'common/parts/image_text_design/',
                    designPattern: [
                        'default',
                        'rounded',
                        'snapp'
                    ]
                };
            },
            props: ['parts_data', 'type', 'edit_id', 'device_sync'],
            mixins: [
                commonMixin, partsMixin
            ],
            components: {
                'loop': loop,
                'image-selecter': imageSelecter,
                'suneditor': suneditor,
            }
        },
        'parts-edit-footer': {
            template: '#parts_edit_footer_template',
            data() {
                return {
                    // ご案内編集箇所
                    index: null,
                };
            },
            props: ['parts_data', 'type', 'edit_id', 'device_sync'],
            mixins: [modalMixin, partsMixin],
            components: {
                'loop': loop,
                'image-selecter': imageSelecter,
                'suneditor': suneditor,
            },
            methods: {
                // ご案内編集モーダルを開く
                show: function (index) {
                    this.index = index;
                    this.$nextTick(() => this.$refs.info_edit.open());
                }
            }
        },
        // コード量が多いパーツはファイル分割している
        'parts-edit-table': partsEditTable,
        'parts-edit-item': partsEditItem,
        'parts-edit-ogaria-tool': partsEditOgariaTool,
        'parts-edit-header': partsEditHeader
    },
    emits: ['update-parts-data'],
    methods: {
        // 編集画面を開く
        show: function (data, index) {
            this.parts_type = data.key;
            this.parts_data = data.data;
            this.index = index;
            this.open();
        },
        // 設定データの更新
        update: async function (event) {
            // バリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            // 看板ブロックの場合は看板画像を生成
            if (this.type === 'build_store' && this.parts_type === 'header') {
                var headerPartsEditor = this.$refs.headerPartsEditor;
                await headerPartsEditor.createCapture();
            }
            event.preventDefault();
            this.emitUpdatValue();
            this.close();
        },
        // -------------------------
        // emit
        // -------------------------

        // 編集内容で更新
        emitUpdatValue: function () {
            this.$emit('update-parts-data', this.parts_data, this.index);
        }

    }
};
